import { styled } from '@mui/material';
import { DesignTokens } from '../specify';

export type GivelifyTableStyleProps = {
    /**
     * Left margin.
     */
    marginLeft?: number | 'auto';
    /**
     * Right margin.
     */
    marginRight?: number | 'auto';
    /**
     * Bottom margin.
     */
    marginBottom?: number | 'auto';
    /**
     * Top margin.
     */
    marginTop?: number | 'auto';
    /**
     * Margin.
     */
    margin?: number | 'auto';
};

export const TBScroller = styled('div')({
    '&::-webkit-scrollbar': {
        width: 0,
        background: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
        background: 'rgb(216, 215, 224)',
    },
});

export const TBTable = styled('table', {
    shouldForwardProp: (prop) =>
        prop !== 'marginLeft' &&
        prop !== 'marginRight' &&
        prop !== 'marginBottom' &&
        prop !== 'marginTop' &&
        prop !== 'margin',
})<GivelifyTableStyleProps>(
    ({ marginLeft, marginRight, marginBottom, marginTop, margin }) => ({
        width: '100%',
        boxSizing: 'border-box',
        tableLayout: 'fixed',
        borderSpacing: 0,
        backgroundColor: DesignTokens.color.textWhite,
        marginLeft: marginLeft ? marginLeft : margin,
        marginTop: marginTop ? marginTop : margin,
        marginRight: marginRight ? marginRight : margin,
        marginBottom: marginBottom ? marginBottom : margin,
    }),
);
